var _rect, _path, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddNewVoteIconThreeGreenStep(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 4.25,
    width: 31.5,
    height: 31.5,
    rx: 15.75,
    fill: "#4ED4A9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0373 25.1392C22.011 25.1392 23.4776 23.9013 23.4776 22.2358C23.4776 20.9432 22.712 20.0036 21.4293 19.7898V19.7102C22.4585 19.397 23.0998 18.5518 23.0998 17.4034C23.0998 15.9616 21.9613 14.679 20.0771 14.679C18.3171 14.679 16.8555 15.7628 16.7958 17.3636H17.989C18.0337 16.3494 18.9982 15.7528 20.0572 15.7528C21.1808 15.7528 21.9066 16.4339 21.9066 17.4631C21.9066 18.5369 21.0664 19.233 19.8583 19.233H19.043V20.3267H19.8583C21.4045 20.3267 22.2646 21.1122 22.2646 22.2358C22.2646 23.3146 21.3249 24.0455 20.0174 24.0455C18.8391 24.0455 17.9045 23.4389 17.8299 22.4545H16.5771C16.6516 24.0554 18.0636 25.1392 20.0373 25.1392Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 4.25,
    width: 31.5,
    height: 31.5,
    rx: 15.75,
    stroke: "#4ED4A9",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#4ED4A9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewVoteIconThreeGreenStep);
export default __webpack_public_path__ + "static/media/AddNewVoteIconThreeGreenStep.b309613e9d5152164e456fd4e24b31a5.svg";
export { ForwardRef as ReactComponent };